import axios from "axios";

const API_URL = "http://127.0.0.1:8000/api";

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("access_token") ||
      "";

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const getFinancialYears = async () => {
  const res = await api.get("/reports/financial-years");
  return res.data;
};

export const getCurrentFinancialYear = async () => {
  const res = await api.get("/reports/financial-years/current");
  return res.data;
};

export const getReportsList = async (
  search = "",
  date = "",
  financialYearId = "",
  dateFrom = "",
  dateTo = ""
) => {
  const params = {};

  if (search) {
    params.search = search;
  }

  if (date) {
    params.date = date;
  }

  if (financialYearId) {
    params.financial_year_id = financialYearId;
  }

  if (dateFrom) {
    params.date_from = dateFrom;
  }

  if (dateTo) {
    params.date_to = dateTo;
  }

  const res = await api.get("/reports/", {
    params,
  });

  return res.data;
};

export const getReportsSummary = async (
  financialYearId = "",
  dateFrom = "",
  dateTo = ""
) => {
  const params = {};

  if (financialYearId) {
    params.financial_year_id = financialYearId;
  }

  if (dateFrom) {
    params.date_from = dateFrom;
  }

  if (dateTo) {
    params.date_to = dateTo;
  }

  const res = await api.get("/reports/summary", {
    params,
  });

  return res.data;
};

const buildParams = (
  financialYearId,
  dateFrom,
  dateTo
) => {
  const params = {};

  if (financialYearId) {
    params.financial_year_id = financialYearId;
  }

  if (dateFrom) {
    params.date_from = dateFrom;
  }

  if (dateTo) {
    params.date_to = dateTo;
  }

  return params;
};

export const getDriverReport = async (
  financialYearId = "",
  dateFrom = "",
  dateTo = ""
) => {
  const res = await api.get("/reports/drivers", {
    params: buildParams(
      financialYearId,
      dateFrom,
      dateTo
    ),
  });

  return res.data;
};

export const getVehicleReport = async (
  financialYearId = "",
  dateFrom = "",
  dateTo = ""
) => {
  const res = await api.get("/reports/vehicles", {
    params: buildParams(
      financialYearId,
      dateFrom,
      dateTo
    ),
  });

  return res.data;
};

export const getSupplierReport = async (
  financialYearId = "",
  dateFrom = "",
  dateTo = ""
) => {
  const res = await api.get("/reports/suppliers", {
    params: buildParams(
      financialYearId,
      dateFrom,
      dateTo
    ),
  });

  return res.data;
};

export const getAssignmentReport = async (
  financialYearId = "",
  dateFrom = "",
  dateTo = ""
) => {
  const res = await api.get("/reports/assignments", {
    params: buildParams(
      financialYearId,
      dateFrom,
      dateTo
    ),
  });

  return res.data;
};

export const getOutstandingReport = async (
  financialYearId = "",
  dateFrom = "",
  dateTo = ""
) => {
  const res = await api.get("/reports/outstanding", {
    params: buildParams(
      financialYearId,
      dateFrom,
      dateTo
    ),
  });

  return res.data;
};

export const getStaffReport = async (
  financialYearId = "",
  dateFrom = "",
  dateTo = ""
) => {
  const res = await api.get("/reports/staff", {
    params: buildParams(
      financialYearId,
      dateFrom,
      dateTo
    ),
  });

  return res.data;
};

export const getVehicleDocumentsReport = async (
  financialYearId = "",
  dateFrom = "",
  dateTo = ""
) => {
  const res = await api.get(
    "/reports/vehicle-documents",
    {
      params: buildParams(
        financialYearId,
        dateFrom,
        dateTo
      ),
    }
  );

  return res.data;
};

export const logReportDownload = async (
  userId,
  reportName,
  reportType = "CSV",
  financialYearId = null
) => {
  const res = await api.post(
    "/reports/download/log",
    {
      user_id: userId,
      report_name: reportName,
      report_type: reportType,
      financial_year_id: financialYearId || null,
    }
  );

  return res.data;
};